import React, { Component } from 'react'
import { checkTranslation, getObject, isWhite, translate } from '../../utils/useful'
import HttpServices from '../../utils/Http.services';
import FixedView from '../FixedView';
import WorkflowViewer from '../../windows/CreateApplet/WorkflowViewer';

class TableStageInput extends Component {

    state = {
        data: [],
        title: '',
        options: [],
        isLoading: false,
        choosen: [],
    }

    componentDidMount() {
        // let data = {}
        // applet: '{{appletId}}', appletHub: "{{appletHub}}", targetHub: "{{targetId}}"
        // data.applet = this.props.applet._id
        // data.appletHub = this.props.applet.hub
        // data.frame = header.information.collection
        // data.value = header.information.field
        // HttpServices.request('getAutomations', this.props.header.information, (fetchResult, fetchError) => {
        //     // fetchResult.info.forEach(el => {
        //     //     if (el.type == "workflow") {
        //     //         let stageMap = el.flow.stageMap
        //     //         let component = el.flow.components
        //     //         for (let i = 0; i < stageMap.length; i++) {
        //     //             const stage = stageMap[i];
        //     //             let currentStage = stage.dest
        //     //             this.stages(stageMap, currentStage, component)

        //     //         }
        //     //     }
        //     // });
        // })
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data || (this.props.fullData && this.props.fullData.stage != prevProps.fullData.stage)) {
            this.init()
        }
    }


    init() {

        // console.log("INIT",this.props.fullData)
        // let stageMap = getObject(this.props.fullData, '**stage.information.workflow.flow.stageMap')

        // let workflow = this.props.fullData["**stage"]?.information?.workflow
        // let value = this.props.fullData["**stage"]?.value?.stage?.id
        let workflow = this.props.fullData?.workflow
        let value = this.props.fullData.stage

        let stages = workflow?.stages



        let data
        let nextStages = []
        let backIsWhite = false
        if (Array.isArray(stages)) {

            stages.forEach(stage => {
                if (stage.id == value) {
                    data = stage
                    backIsWhite = isWhite(data.color?.background)

                }
            });


            stages.forEach(stage => {
                if (data && Array.isArray(data.to) && data.to.includes(stage.id)) {
                    nextStages.push(stage)
                }

            })
        }



        this.setState({ data, stages, nextStages, backIsWhite })

    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }
    getLabel(key) {
        if (this.props.data) {
            // console.log('this.props.datafirst',this.props.data)
            let data = this.props.data
            if (key == 'title') {
                // return data.stages[0].name
                return getObject(this.props.data, 'name')
            }
            // else {
            //     // return data.stages[0].name
            //     return getObject(this.props.data, '**stages.name')
            // }


            // if (typeof this.props.data == 'object') {
            //     return getObject(this.props.data, '**stage.value.stage.name')
            // } else {
            //     if (this.props.header?.information?.items?.length) {
            //         for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
            //             const item = this.props.header?.information?.items[i];
            //             if (item.value == this.props.data) {
            //                 return item[key]
            //             }
            //         }
            //     }
            // }
        } else {
            if (this.props.header?.information?.default) {
                for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                    const item = this.props.header?.information?.items[i];
                    if (item.value == this.props.header?.information?.default) {
                        return item[key]
                    }
                }
            } else {
                return ' '
            }
        }

    }
    // getLabel(key) {
    //     if (this.props.data) {
    //         if (typeof this.props.data == 'object') {

    //             // return getObject(this.props.data, this.props.header?.information?.fields?.title)
    //             return getObject(this.props.data, '**stage.value.stage.name')
    //         } else {
    //             if (this.props.header?.information?.items?.length) {
    //                 for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
    //                     const item = this.props.header?.information?.items[i];
    //                     if (item.value == this.props.data) {
    //                         return item[key]
    //                     }
    //                 }
    //             }
    //         }
    //     } else {
    //         if (this.props.header?.information?.default) {
    //             for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
    //                 const item = this.props.header?.information?.items[i];
    //                 if (item.value == this.props.header?.information?.default) {
    //                     return item[key]
    //                 }
    //             }
    //         } else {
    //             return ' '
    //         }
    //     }

    // }
    stagesMap(data) {
        let stageMap
        let stageComponent
        let trigger
        let stageMapArray = []
        if (this.props.fullData) {
            stageMap = getObject(this.props.fullData, 'workflow.flow.stageMap')
            // stageMap.forEach(stage => {
            //     stageMapArray.push(getObject(this.props.fullData, `**stage.information.workflow.flow.components.${stage.dest}`))

            // });
            // stageComponents = getObject(this.props.fullData, '**stage.information.components')
        }


        if (Array.isArray(stageMap)) {
            return (
                <div className='flexc w-100 sc-2' style={{ overflowX: 'scroll' }}>
                    {stageMap.map((stage, index) => {
                        if (stage.type == 'trigger') {
                            trigger = getObject(this.props.fullData, `workflow.flow.components.${stage.src}`)
                        }
                        stageComponent = getObject(this.props.fullData, `workflow.flow.components.${stage.dest}`)


                        return (
                            <div ref={el => this.content = el} key={index} className=" flexcc w-100" style={{ position: 'relative', border: stageComponent?.UI?.border, backgroundImage: 'linear-gradient(' + stageComponent?.UI?.bodyColorS + ',' + stageComponent?.UI?.bodyColorE + ')', borderRadius: stageComponent?.UI?.borderRadius, width: stageComponent?.UI?.width, minHeight: stageComponent?.UI?.height, }}>
                                <div className="d-flex w-100" style={{}} >
                                    <div className="w-100  flexcc flex-column">
                                        <div className="pld-2 prd-2 flexcc flex-column pb-2">
                                            <div className="flexcb mt-2  text-center " style={{}}>
                                                <div className="br-6 px-1 py-1 br-20" style={{ backgroundColor: 'rgb(235,29,101)' }}>
                                                    <div className="invert  flexcc">
                                                        <img className={" " + (stageComponent?.UI?.showIcon ? "invert" : '')} src={(stageComponent?.UI?.showIcon ?? '/assets/icons/elements/stage.svg')} height={'13px'} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div ref={el => this.labelContainer = el} className="mt-1 " style={{ maxWidth: stageComponent?.UI?.width - 16, overflow: 'hidden', position: 'relative' }}>
                                                <p className="  text-semibold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 13 }}>{checkTranslation(stageComponent?.title)}</p>
                                                <p ref={el => this.label = el} className="  text-semibold" style={{ color: stageComponent?.UI?.textColor, textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap', fontSize: 13, position: 'absolute', left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(stageComponent?.title)}</p>
                                            </div>
                                            {/* <div>
                                                 <p className="text-smallest opacity-5">Flow control</p>
                                             </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            // <div className="w-100 h-100 flexc py-1" key={index} style={{}}>
                            //     <div className="flexcc stageMap br-5" style={{ backgroundColor: getObject(this.props.data, 'id') == stageComponent.key ? 'red' : '' }}>
                            //         <p>{checkTranslation(stageComponent.title)}</p>
                            //     </div>
                            // </div>
                        )
                    }
                    )}
                </div>
            )
        }
    }
    // stagesMap() {
    //     let stageMap
    //     let stageComponent
    //     let trigger
    //     let array = []
    //     if (this.props.fullData) {
    //         stageMap = getObject(this.props.fullData, '**stage.information.workflow.flow.stageMap')
    //         // stageComponents = getObject(this.props.fullData, '**stage.information.components')
    //     }
    //     if (Array.isArray(stageMap)) {
    //         return (
    //             <div className='flexc w-100' style={{ overflowX: 'scroll' }}>
    //                 {stageMap.map((stage, index) => {
    //                     if (stage.type == 'trigger') {
    //                         trigger = getObject(this.props.fullData, `**stage.information.workflow.flow.components.${stage.src}`)
    //                     }
    //                     stageComponent = getObject(this.props.fullData, `**stage.information.workflow.flow.components.${stage.dest}`)
    //                     return (
    //                         <div ref={el => this.content = el} className=" flexcc w-100" style={{ position: 'relative', border: stageComponent?.UI?.border, backgroundImage: 'linear-gradient(' + stageComponent?.UI?.bodyColorS + ',' + stageComponent?.UI?.bodyColorE + ')', borderRadius: stageComponent?.UI?.borderRadius, width: stageComponent?.UI?.width, minHeight: stageComponent?.UI?.height, }}>
    //                             <div className="d-flex w-100" style={{}} >
    //                                 <div className="w-100  flexcc flex-column">
    //                                     <div className="pld-2 prd-2 flexcc flex-column pb-2">
    //                                         <div className="flexcb mt-2  text-center " style={{}}>
    //                                             <div className="br-6 px-1 py-1 br-20" style={{ backgroundColor: 'rgb(235,29,101)' }}>
    //                                                 <div className="invert  flexcc">
    //                                                     <img className={" " + (stageComponent?.UI?.showIcon ? "invert" : '')} src={(stageComponent?.UI?.showIcon ?? '/assets/icons/elements/stage.svg')} height={'13px'} />
    //                                                 </div>
    //                                             </div>
    //                                         </div>
    //                                         <div ref={el => this.labelContainer = el} className="mt-1 " style={{ maxWidth: stageComponent?.UI?.width - 16, overflow: 'hidden', position: 'relative' }}>
    //                                             <p className="  text-semibold" style={{ color: 'transparent', whiteSpace: 'nowrap', fontSize: 13 }}>{checkTranslation(stageComponent?.title)}</p>
    //                                             <p ref={el => this.label = el} className="  text-semibold" style={{ color: stageComponent?.UI?.textColor, textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap', fontSize: 13, position: 'absolute', left: 0, top: 0, transition: 'left 2s' }}>{checkTranslation(stageComponent?.title)}</p>
    //                                         </div>
    //                                         {/* <div>
    //                                             <p className="text-smallest opacity-5">Flow control</p>
    //                                         </div> */}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         // <div className="w-100 h-100 flexc py-1" style={{}}>
    //                         //     {index == 0 &&
    //                         //         <div className="flexcc stageMap br-5" style={{ width: '135px' }}>
    //                         //             <p>{checkTranslation(trigger.title)}</p>
    //                         //         </div>

    //                         //     }
    //                         //     <div className="flexcc stageMap br-5" style={{}}>
    //                         //         <p>{checkTranslation(stageComponent.title)}</p>
    //                         //     </div>
    //                         //     {stageComponent.nodes &&
    //                         //         <div className="" style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }} >
    //                         //             <div >
    //                         //                 {Object.values(stageComponent.nodes)?.map((nprop, index) => {
    //                         //                     if (nprop.position == 'right') {
    //                         //                         return (
    //                         //                             <div key={index} className="flexc mb-2 mt-1" style={{ justifyContent: 'flex-end', marginRight: -7 }}>
    //                         //                                 {/* <p className="text-smallest mx-1">{nprop.label}</p> */}
    //                         //                                 <div ref={el => this[nprop.key] = el} className="flexcc" style={{ zIndex: 7 }}>
    //                         //                                     <div className="contactBut">
    //                         //                                     </div>
    //                         //                                 </div>

    //                         //                             </div>
    //                         //                         )
    //                         //                     }
    //                         //                 })}

    //                         //             </div>
    //                         //         </div>
    //                         //     }
    //                         //     {/* <div>
    //                         //         <img src='/assets/'
    //                         //     </div> */}
    //                         // </div>
    //                     )
    //                 })
    //                 }
    //             </div>
    //         )
    //     }
    // }

    showChangeFixed = () => {
        this.setState({ showChangeFixed: true }, () => {
            this.changeFixedView.showView()
        })
    }

    render() {
        let hasNext = Array.isArray(this.state.nextStages) && this.state.nextStages.length > 0
        let hasPrevious = Array.isArray(this.state.nextStages) && this.state.nextStages.length > 0


        return (
            <div className='w-100 h-100 flexc'>
                {this.state.data && (
                    <div className='flexc' style={{ minWidth: 0 }}>
                        <div className=" flexc w-100 cursor-pointer" ref={el => this.currentNode = el} onClick={() => { this.fixedView.showView() }} style={{ borderRadius: 20, padding: '6px 14px', border: this.state.backIsWhite ? '1px solid #f2f2f2' : null, color: this.state.data?.color?.text ?? '#000', backgroundColor: this.state.data?.color?.background ?? '#fff', }}>
                            <p className="text-semibold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.state.data?.name)} </p>
                        </div>
                    </div>
                )}
                <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={() => { }} topOffset={5} xOffset={30} zIndex={15} width={300} >
                    <div className='br-8 pb-2' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 30px #10101020', }}>
                        {/* {this.stagesMap()} */}
                        <div className='px-3 pt-2 text-bold flexcb'>
                            <p className=''>{translate("Workflow map")}</p>

                            <button ref={(el) => this.butNode = el} onClick={() => { this.showChangeFixed() }}>
                                <p className='text-link text-semibold'>{translate("Change stage")}</p>
                            </button>
                        </div>
                        <WorkflowViewer width={this.props.width} variables={this.props.variables} stages={this.state.stages} currentStage={this.state.data} />

                        {/* <div className='px-2 mt-2 pb-4'>
                            <p className='text-semibold mb-2'>Go to</p>
                            <div className='flexcb'>
                                <div className='pr-20 px-2 py-1 br-8 mrd-2 text-bold' style={{ background: '#eee' }}>
                                    <p>Next stage</p>
                                </div>

                                <div className='pr-20 px-2 py-1 br-8 mld-2' style={{ background: '#eee' }}>
                                    <p>Stage ...</p>
                                </div>

                            </div>
                        </div> */}


                        {this.state.showChangeFixed && (
                            <FixedView ref={el => this.changeFixedView = el} nodeRef={this.butNode} onHide={() => { }} topOffset={5} xOffset={0} zIndex={15} width={240} >
                                <div className='br-8 pb-2 ' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 30px #10101020', }}>
                                    {/* {this.stagesMap()} */}

                                    <div className=' pt-2 mt-2 mb-2  flexcb'>
                                        <p className='text-bold font-size-14' style={{ margin: '0px 12px' }}>{translate("Change stage to")}</p>
                                    </div>

                                    <div className='sc-gray2' style={{ overflow: 'auto', maxHeight: 300, }} >

                                        {hasNext && (
                                            <div className='px-2 mt-1 text-bold d-flex flex-column ' >
                                                <div className='flexcb w-100'>
                                                    <button className=' text-bold  text-start br-20 flexc white' style={{ padding: '6px 6px', background: 'rgb(0, 191, 96)' }}>
                                                        <img className='rotate-0 invert' src='/assets/icons/useful/right (1).png' height={20} alt='' />
                                                        <div className='mld-2 mrd-4'>
                                                            <p className='font-size-13'>{translate("Next stage")}</p>

                                                        </div>
                                                    </button>

                                                    <button className=' text-semibold text-smaller br-20 mld-2' style={{ padding: '6px 12px', maxWidth: 100, background: this.state.nextStages[0]?.color?.background }}>
                                                        <p className=''>{checkTranslation(this.state.nextStages[0].name)}</p>
                                                    </button>
                                                </div>

                                                {/* {Array.isArray(this.state.nextStages) && this.state.nextStages.length == 1 && (
                                                    <div className='px-2 mt-1'>
                                                        <p className='text-smaller text-semibold '>{checkTranslation(this.state.nextStages[0].name)}</p>
                                                    </div>
                                                )} */}

                                            </div>
                                        )}


                                        {hasPrevious && (
                                            <div className='px-2 mt-2 text-bold d-flex flex-column ' >
                                                <div className='flexcb'>
                                                    <div>
                                                        <button className=' text-bold br-20  flexc color-gray-1 text-start' style={{ padding: '6px 6px', background: '#eee' }}>
                                                            <img className='rotate-180 opacity-7' src='/assets/icons/useful/right (1).png' height={20} alt='' />
                                                            <div className='mld-2 mrd-4'>
                                                                <p className='font-size-13'>{translate("Last stage")} </p>
                                                                {/* {Array.isArray(this.state.nextStages) && this.state.nextStages.length == 1 && (
                                                            <div className=''>
                                                                <p className='text-smallest text-semibold '>{checkTranslation("Stage name")}</p>
                                                            </div>
                                                        )} */}
                                                            </div>
                                                        </button>
                                                    </div>

                                                    <button className=' text-semibold text-smaller br-20 mld-2' style={{ padding: '6px 12px', maxWidth: 100, background: this.state.nextStages[0]?.color?.background }}>
                                                        <p className='w-100' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>{checkTranslation('Stage name e dwq dqw dfqwfe')}</p>
                                                    </button>
                                                </div>
                                                {/* {Array.isArray(this.state.nextStages) && this.state.nextStages.length == 1 && (
                                                    <div className='px-2'>
                                                        <p className='text-smaller text-semibold mt-1'>{checkTranslation("Stage name")}</p>
                                                    </div>
                                                )} */}
                                            </div>
                                        )}

                                        {(hasNext || hasPrevious) && (
                                            <div className='w-100 mt-3 mb-3' style={{ height: 1, background: '#eee' }}></div>
                                        )}


                                        <div className='d-flex flex-column text-start px-2 mt-1'>
                                            {this.state.stages?.map((prop, index) => {

                                                if (prop.type != 'trigger') {
                                                    let isCurrent = this.state.data?.id == prop.id
                                                    return (
                                                        <div className='flexc mb-2 '>
                                                            <button className=' text-semibold font-size-12 br-20' style={{ padding: '6px 12px', opacity: isCurrent ? '0.5' : 1, background: prop.color?.background }}>
                                                                <p className=''>{checkTranslation(prop.name)}</p>
                                                            </button>
                                                            {isCurrent && (
                                                                <p className='text-smaller mld-2 br-20  py-1' style={{ background: '', color: '#bbb' }}>{translate('Current stage')}</p>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            })}

                                        </div>




                                    </div>
                                </div>
                            </FixedView>
                        )}

                    </div>
                </FixedView>
            </div>
        )
    }
}

export default TableStageInput;